import { useEffect, useState } from 'react'

interface IWindowSizeProps {
  windowSize: { width: string | number; height: string | number }
  isMobile: boolean
  isMediumMobile: boolean
}

export default function useWindowSize(): IWindowSizeProps {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  })
  const [isMobile, setIsMobile] = useState<boolean>()
  const [isMediumMobile, setIsMediumMobile] = useState<boolean>()
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window?.innerWidth,
        height: window?.innerHeight,
      })
      setIsMobile(window?.innerWidth <= 639)
      setIsMediumMobile(window?.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window?.removeEventListener('resize', handleResize)
  }, [])

  return { windowSize, isMobile, isMediumMobile }
}
